import { useGetParams } from '../../hooks/useGetParams';
import styles from './Variant.module.css';
import { motion } from 'framer-motion';

import checked from '../../assets/images/checked.png';

export const Variant = ({
  item,
  index,
  isQuestionImg,
  isStateCorrectVar,
  aciveAmimate,
}) => {
  const { answerFontSize, varNumFontSize } = useGetParams();

  // анимация правильного варианта
  const titleVariants = {
    inactive: {
      color: '#18458A',
      backgroundImage: 'linear-gradient(90deg, #ffffff, #ffffff)',
    },
    active: {
      color: ['#18458A', '#ffffff', '#18458A', '#ffffff'],
      backgroundImage: [
        'linear-gradient(90deg, #ffffff, #ffffff)',
        'linear-gradient(90deg, #00C091, #3F9D00)',
        'linear-gradient(90deg, #ffffff, #ffffff)',
        'linear-gradient(90deg, #00C091, #3F9D00)',
      ],
    },
  };

  const numberVariants = {
    inactive: {
      opacity: 1,
    },
    active: {
      opacity: 0,
    },
  };

  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: !isStateCorrectVar ? 1 : aciveAmimate ? 1 : 0.5 }}
      transition={{ duration: 0.28, ease: 'easeInOut' }}
      className={styles.variant}
    >
      <motion.div
        className={styles.varNumber}
        style={{
          fontSize: `${varNumFontSize}rem`,
          height: `${1.8 * varNumFontSize}rem`,
          minWidth: `${1.8 * varNumFontSize}rem`,
        }}
      >
        <motion.div
          variants={numberVariants}
          initial="inactive"
          animate={aciveAmimate ? 'active' : 'inactive'}
          transition={{ duration: 0.48 }}
        >
          {index + 1}
        </motion.div>

        <motion.div
          className={styles.correctBg}
          initial={{ opacity: 1 }}
          animate={{ opacity: aciveAmimate ? 1 : 0 }}
          transition={{ duration: 0.48, ease: 'easeInOut' }}
        />

        <motion.img
          className={styles.checked}
          src={checked}
          alt="checked"
          initial={{ scale: 0 }}
          animate={{ scale: aciveAmimate ? [0, 1.2, 1] : 0 }}
          transition={{ duration: 1, ease: 'easeInOut', times: [0, 0.8, 1] }}
        />
      </motion.div>
      <motion.div
        variants={titleVariants}
        initial="inactive"
        animate={aciveAmimate ? 'active' : 'inactive'}
        transition={{ duration: 1.48 }}
        className={styles.varTitle}
        style={{
          fontSize: `${answerFontSize}rem`,
          maxWidth: '95rem',
        }}
      >
        {item.comment}
      </motion.div>
    </motion.div>
  );
};
